/* ===========================================================
   TECH DEPOT INDIA — homepage script
   Premium PBR drone + scroll/tilt animations + static-product fallback
   =========================================================== */

/* ---------- Static featured products (fallback when no `best-sellers` collection exists yet) ---------- */
(function bootFeaturedFallback(){
  if(!window.__td_use_static_products__) return;
  var row=document.getElementById('best-row');
  if(!row || row.children.length>0) return;
  var products = [
    {title:"Raspberry Pi 5 16GB — BCM2712",price:34450,vendor:"RASPBERRY PI",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014943/tech_depot/635057022b357a770f41e87b24c5c67a.jpg",badge:{text:"NEW",cls:"new"}},
    {title:"Arduino Uno R4 WiFi — Official India Edition",price:1483,vendor:"ARDUINO",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014459/tech_depot/1c9fbd5b1f80d6594c210fed1ac13cc9.jpg",badge:{text:"BESTSELLER",cls:"hot"}},
    {title:"Holybro Pixhawk Jetson Baseboard",price:62959,vendor:"HOLYBRO",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014460/tech_depot/502d01e3cb06e7690ce27203781f8f67.png",badge:{text:"PRO",cls:"pro"}},
    {title:"NVIDIA Jetson Nano Carrier Board",price:8197,vendor:"NVIDIA",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014826/tech_depot/0726057b511bc1094b0c14f3936555dc.jpg",badge:{text:"AI READY",cls:"new"}},
    {title:"A7670C GSM 4G Breakout Board",price:1784,vendor:"ADIY",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014963/tech_depot/7fdba5fa99fd59426e10b2ca46468aad.jpg",badge:{text:"IN STOCK",cls:""}},
    {title:"R307 Fingerprint Sensor Module",price:922,vendor:"GENERIC",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014928/tech_depot/f9090790b4bc473e53fe8fb5f9adaab1.jpg",badge:{text:"BESTSELLER",cls:"hot"}},
    {title:"Bosch GTC 600 C Thermal Camera",price:105232,vendor:"BOSCH",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014906/tech_depot/2159dd7f4b6e84114894576fb47e07db.jpg",badge:{text:"PRO",cls:"pro"}},
    {title:"Arduino Nano ESP32 — Pro IoT MCU",price:2332,vendor:"ARDUINO",img:"https://res.cloudinary.com/dbq2q7rm3/image/upload/v1778014458/tech_depot/eef1e1ea699f3f4753ecda4778c877e5.jpg",badge:{text:"NEW",cls:"new"}}
  ];
  row.innerHTML=products.map(function(p){
    var badgeCls=p.badge?(p.badge.cls==='hot'?'hot':p.badge.cls==='new'?'new':p.badge.cls==='pro'?'pro':''):'stock';
    var badgeText=p.badge?p.badge.text:'In stock';
    var saleRound=p.badge&&p.badge.cls==='hot'?' sale-round':'';
    return '<a href="/collections/all" class="product-card card-3d"><div class="product-img">'
      + '<span class="badge'+saleRound+' '+badgeCls+'">'+badgeText+'</span>'
      + '<img src="'+p.img+'" alt="'+p.title+'" loading="lazy"></div>'
      + '<div class="product-info"><h4>'+p.title+'</h4>'
      + '<div class="price-row"><div class="price"><span class="from-label">From</span><span class="currency">₹</span>'+p.price.toLocaleString('en-IN')+'</div>'
      + '<span class="add-cart" aria-label="Add to cart">+</span></div></div></a>';
  }).join('');
})();

/* ============ 3D DRONE HERO — lazy load, desktop only ============ */
(function bootThreeDrone(){
  var canvas=document.getElementById('three-canvas');
  if(!canvas)return;
  var heroCanvas=canvas.parentElement;
  function showCta(){document.querySelectorAll('#drone-cta-text span,#drone-cta-pill').forEach(function(e){e.classList.add('show');});}
  if(window.matchMedia('(max-width:768px)').matches||window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    canvas.remove();showCta();return;
  }
  if(heroCanvas)heroCanvas.classList.add('is-loading');
  var CDN={three:'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js',gsap:'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js'};
  var libsReady=0;
  function loadScript(src,ok){var s=document.createElement('script');s.src=src;s.async=true;s.onload=ok;s.onerror=ok;document.head.appendChild(s);}
  function onLibsReady(){
    if(++libsReady<2)return;
    if(!window.THREE){showCta();if(heroCanvas)heroCanvas.classList.remove('is-loading');return;}
    requestAnimationFrame(function(){requestAnimationFrame(function(){runThreeDrone(canvas,showCta,heroCanvas);});});
  }
  function startLibs(){
    loadScript(CDN.three,onLibsReady);
    loadScript(CDN.gsap,onLibsReady);
  }
  function scheduleDrone(){
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries,o){
        if(entries[0].isIntersecting){o.disconnect();startLibs();}
      },{rootMargin:'50px'}).observe(canvas);
    }else{startLibs();}
  }
  if('requestIdleCallback' in window){requestIdleCallback(scheduleDrone,{timeout:3000});}
  else{setTimeout(scheduleDrone,400);}
})();
function runThreeDrone(canvas,showCta,heroCanvas){
  if(!window.THREE){showCta();return;}
  var T=THREE;

  // -------- RENDERER (color-managed, tone-mapped, soft shadows) --------
  var renderer=new T.WebGLRenderer({canvas:canvas,alpha:true,antialias:window.devicePixelRatio<2,powerPreference:'high-performance'});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,1.5));
  if('outputColorSpace' in renderer) renderer.outputColorSpace=T.SRGBColorSpace;
  renderer.toneMapping=T.ACESFilmicToneMapping;
  renderer.toneMappingExposure=1.18;
  renderer.shadowMap.enabled=true;
  renderer.shadowMap.type=T.PCFSoftShadowMap;

  // -------- SCENE / CAMERA --------
  var scene=new T.Scene();
  var cam=new T.PerspectiveCamera(38,1,.1,100);
  cam.position.set(0,1.2,5.4);
  function resize(){var r=canvas.parentElement.getBoundingClientRect();renderer.setSize(r.width,r.height,false);cam.aspect=r.width/r.height;cam.updateProjectionMatrix()}
  resize();
  if(window.ResizeObserver){new ResizeObserver(resize).observe(canvas.parentElement);}else{window.addEventListener('resize',resize);}

  // -------- PROCEDURAL HDRI-ISH ENVIRONMENT --------
  function buildEnvCanvas(){
    var c=document.createElement('canvas');c.width=512;c.height=256;
    var x=c.getContext('2d');
    var sky=x.createLinearGradient(0,0,0,128);
    sky.addColorStop(0,'#fefcff');sky.addColorStop(.55,'#e6eaff');sky.addColorStop(1,'#ffd9ec');
    x.fillStyle=sky;x.fillRect(0,0,512,128);
    var fl=x.createLinearGradient(0,128,0,256);
    fl.addColorStop(0,'#c9d3f2');fl.addColorStop(1,'#7c8ab6');
    x.fillStyle=fl;x.fillRect(0,128,512,128);
    [[90,55,150],[260,40,110],[420,70,130]].forEach(function(s){
      var cx=s[0],cy=s[1],r=s[2];
      var g=x.createRadialGradient(cx,cy,2,cx,cy,r);
      g.addColorStop(0,'rgba(255,255,255,1)');g.addColorStop(.35,'rgba(255,255,255,.55)');g.addColorStop(1,'rgba(255,255,255,0)');
      x.fillStyle=g;x.fillRect(cx-r,cy-r,r*2,r*2);
    });
    var a=x.createRadialGradient(60,180,5,60,180,100);
    a.addColorStop(0,'rgba(99,102,241,.55)');a.addColorStop(1,'rgba(99,102,241,0)');
    x.fillStyle=a;x.fillRect(0,100,150,120);
    var b=x.createRadialGradient(450,190,5,450,190,130);
    b.addColorStop(0,'rgba(236,72,153,.5)');b.addColorStop(1,'rgba(236,72,153,0)');
    x.fillStyle=b;x.fillRect(320,100,192,156);
    var hb=x.createLinearGradient(0,125,0,131);
    hb.addColorStop(0,'rgba(70,80,120,0)');hb.addColorStop(.5,'rgba(50,60,90,.5)');hb.addColorStop(1,'rgba(70,80,120,0)');
    x.fillStyle=hb;x.fillRect(0,125,512,6);
    return c;
  }
  var envTex=new T.CanvasTexture(buildEnvCanvas());
  envTex.mapping=T.EquirectangularReflectionMapping;
  if('colorSpace' in envTex) envTex.colorSpace=T.SRGBColorSpace;
  var pmrem=new T.PMREMGenerator(renderer);
  var envMap=pmrem.fromEquirectangular(envTex).texture;
  scene.environment=envMap;
  envTex.dispose();pmrem.dispose();

  // -------- TEXTURES --------
  function brushedTex(){
    var c=document.createElement('canvas');c.width=512;c.height=512;
    var x=c.getContext('2d');
    x.fillStyle='#3a4150';x.fillRect(0,0,512,512);
    for(var i=0;i<1600;i++){
      var y=Math.random()*512,sx=Math.random()*512,len=15+Math.random()*130;
      x.strokeStyle='rgba(255,255,255,'+(0.015+Math.random()*0.06)+')';
      x.lineWidth=0.5;x.beginPath();x.moveTo(sx,y);x.lineTo(sx+len,y);x.stroke();
    }
    var t=new T.CanvasTexture(c);if('colorSpace' in t) t.colorSpace=T.SRGBColorSpace;
    t.wrapS=t.wrapT=T.RepeatWrapping;t.anisotropy=8;return t;
  }
  function carbonTex(){
    var s=256,c=document.createElement('canvas');c.width=c.height=s;
    var x=c.getContext('2d');x.fillStyle='#0a0a10';x.fillRect(0,0,s,s);
    var tile=8;
    for(var yy=0;yy<s;yy+=tile){
      for(var xx=0;xx<s;xx+=tile){
        var odd=(((xx/tile)+(yy/tile))%2)===0;
        var g=x.createLinearGradient(xx,yy,xx+tile,yy+tile);
        if(odd){g.addColorStop(0,'#181822');g.addColorStop(.5,'#2c2c38');g.addColorStop(1,'#0e0e14');}
        else  {g.addColorStop(0,'#0e0e14');g.addColorStop(.5,'#181822');g.addColorStop(1,'#2c2c38');}
        x.fillStyle=g;x.fillRect(xx,yy,tile,tile);
      }
    }
    var t=new T.CanvasTexture(c);if('colorSpace' in t) t.colorSpace=T.SRGBColorSpace;
    t.wrapS=t.wrapT=T.RepeatWrapping;t.repeat.set(2,2);t.anisotropy=8;return t;
  }
  function glowTex(){
    var c=document.createElement('canvas');c.width=c.height=128;
    var x=c.getContext('2d');
    var g=x.createRadialGradient(64,64,0,64,64,64);
    g.addColorStop(0,'rgba(255,255,255,1)');g.addColorStop(.3,'rgba(255,255,255,.45)');g.addColorStop(1,'rgba(255,255,255,0)');
    x.fillStyle=g;x.fillRect(0,0,128,128);
    return new T.CanvasTexture(c);
  }
  function shadowTex(){
    var c=document.createElement('canvas');c.width=c.height=256;
    var x=c.getContext('2d');
    var g=x.createRadialGradient(128,128,8,128,128,128);
    g.addColorStop(0,'rgba(0,0,0,.55)');g.addColorStop(.45,'rgba(0,0,0,.18)');g.addColorStop(1,'rgba(0,0,0,0)');
    x.fillStyle=g;x.fillRect(0,0,256,256);
    return new T.CanvasTexture(c);
  }
  var TEX_BRUSHED=brushedTex();
  var TEX_CARBON=carbonTex();
  var TEX_GLOW=glowTex();

  // -------- PBR MATERIALS --------
  var usePhys=!!T.MeshPhysicalMaterial;
  var Phys=usePhys?T.MeshPhysicalMaterial:T.MeshStandardMaterial;
  var matChassis=new Phys({color:0x191b29,metalness:1.0,roughness:.20,clearcoat:1.0,clearcoatRoughness:.08,envMapIntensity:1.5});
  var matCanopy =new Phys({color:0x07070d,metalness:.55,roughness:.04,clearcoat:1.0,clearcoatRoughness:.02,envMapIntensity:2.2,reflectivity:1});
  var matBrushed=new Phys({map:TEX_BRUSHED,metalness:1.0,roughness:.32,clearcoat:.4,clearcoatRoughness:.3,envMapIntensity:1.6});
  var matCarbon =new Phys({map:TEX_CARBON,metalness:.35,roughness:.55,clearcoat:1.0,clearcoatRoughness:.18,envMapIntensity:1.0});
  var matMotor  =new Phys({color:0x252837,metalness:1.0,roughness:.28,clearcoat:.65,clearcoatRoughness:.2,envMapIntensity:1.5});
  var matMotorTop=new Phys({map:TEX_BRUSHED,metalness:1.0,roughness:.22,clearcoat:.6,envMapIntensity:1.7});
  var matProp   =new Phys({color:0x05060b,metalness:.25,roughness:.16,clearcoat:1.0,clearcoatRoughness:.05,envMapIntensity:1.3});
  if(usePhys){matProp.sheen=.6;matProp.sheenColor=new T.Color(0x6366f1);}
  var matLensRing=new Phys({color:0x07070d,metalness:1.0,roughness:.15,envMapIntensity:1.6});
  var matLens   =new T.MeshStandardMaterial({color:0x0ea5b9,emissive:0x22d3ee,emissiveIntensity:2.6,metalness:.4,roughness:.05});
  var matAccent =new T.MeshStandardMaterial({color:0x6366f1,emissive:0x6366f1,emissiveIntensity:2.2,roughness:.4,metalness:.3});
  var matLEDWhite=new T.MeshStandardMaterial({color:0xffffff,emissive:0xffffff,emissiveIntensity:3.2,roughness:.2});
  var matLEDRed =new T.MeshStandardMaterial({color:0xff3a4f,emissive:0xff3a4f,emissiveIntensity:3.2,roughness:.2});
  var matLEDGreen=new T.MeshStandardMaterial({color:0x22ff8a,emissive:0x22ff8a,emissiveIntensity:3.2,roughness:.2});

  // -------- LIGHTS --------
  scene.add(new T.AmbientLight(0xffffff,.30));
  var key=new T.DirectionalLight(0xffffff,1.5);key.position.set(3.5,5,4);
  key.castShadow=true;key.shadow.mapSize.set(512,512);
  key.shadow.camera.near=.5;key.shadow.camera.far=14;
  key.shadow.camera.left=-3;key.shadow.camera.right=3;key.shadow.camera.top=3;key.shadow.camera.bottom=-3;
  key.shadow.bias=-0.0005;key.shadow.radius=4;scene.add(key);
  var fillPink=new T.PointLight(0xec4899,1.6,9,2);fillPink.position.set(-2.4,-.4,2.4);scene.add(fillPink);
  var fillCyan=new T.PointLight(0x22d3ee,1.1,9,2);fillCyan.position.set(2.4,1.7,-2);scene.add(fillCyan);
  var rim=new T.DirectionalLight(0x9aaeff,.6);rim.position.set(-2.5,2,-3);scene.add(rim);

  // -------- BACKGROUND PARTICLES --------
  var pGeo=new T.BufferGeometry();var NN=60;var pos=new Float32Array(NN*3);
  for(var i2=0;i2<NN*3;i2++)pos[i2]=(Math.random()-.5)*9;
  pGeo.setAttribute('position',new T.BufferAttribute(pos,3));
  var points=new T.Points(pGeo,new T.PointsMaterial({color:0x6366f1,size:.04,transparent:true,opacity:.45,depthWrite:false}));
  scene.add(points);

  // -------- CONTACT SHADOW DISC --------
  var shadowDisc=new T.Mesh(new T.CircleGeometry(1.5,48),new T.MeshBasicMaterial({map:shadowTex(),transparent:true,depthWrite:false}));
  shadowDisc.rotation.x=-Math.PI/2;shadowDisc.position.y=-1.05;scene.add(shadowDisc);

  // -------- DRONE ROOT --------
  var drone=new T.Group();scene.add(drone);
  var parts=[];
  function addPart(mesh,targetPos,startOffset,targetRot){
    mesh.userData.targetPos={x:targetPos.x,y:targetPos.y,z:targetPos.z};
    mesh.userData.targetRot=targetRot||{x:mesh.rotation.x,y:mesh.rotation.y,z:mesh.rotation.z};
    mesh.position.set(targetPos.x+startOffset.x,targetPos.y+startOffset.y,targetPos.z+startOffset.z);
    var tr=mesh.userData.targetRot;
    mesh.rotation.set(tr.x+(Math.random()-.5)*Math.PI*1.4,tr.y+(Math.random()-.5)*Math.PI*1.4,tr.z+(Math.random()-.5)*Math.PI*1.4);
    mesh.scale.set(.001,.001,.001);
    drone.add(mesh);parts.push(mesh);return mesh;
  }

  // CHASSIS
  var chassis=new T.Group();
  var cLow=new T.Mesh(new T.CylinderGeometry(.55,.7,.13,8),matChassis);cLow.castShadow=true;cLow.receiveShadow=true;
  chassis.add(cLow);
  var belt=new T.Mesh(new T.TorusGeometry(.6,.012,12,40),matAccent);belt.rotation.x=Math.PI/2;
  chassis.add(belt);
  var cMid=new T.Mesh(new T.CylinderGeometry(.45,.55,.07,8),matChassis);cMid.position.y=.10;cMid.castShadow=true;
  chassis.add(cMid);
  addPart(chassis,{x:0,y:0,z:0},{x:-7,y:5,z:-2});

  // CANOPY
  var canopy=new T.Mesh(new T.SphereGeometry(.32,32,20,0,Math.PI*2,0,Math.PI/2.2),matCanopy);canopy.castShadow=true;
  addPart(canopy,{x:0,y:.135,z:0},{x:7,y:5,z:1});
  var canopyRing=new T.Mesh(new T.TorusGeometry(.34,.008,10,42),matAccent);canopyRing.rotation.x=Math.PI/2;
  addPart(canopyRing,{x:0,y:.125,z:0},{x:6,y:5,z:0});

  // ANTENNAS
  for(var s=-1;s<=1;s+=2){
    var ant=new T.Mesh(new T.CylinderGeometry(.012,.018,.24,8),matBrushed);
    addPart(ant,{x:.16*s,y:.30,z:-.20},{x:s*4,y:6,z:-3},{x:.18,y:0,z:0});
    var tip=new T.Mesh(new T.SphereGeometry(.028,12,8),matAccent);
    addPart(tip,{x:.16*s,y:.42,z:-.22},{x:s*4,y:7,z:-3});
  }

  // ARMS + MOTORS + 3-BLADE PROPELLERS
  var armDirs=[{x:8,y:2,z:-8},{x:-8,y:2,z:-8},{x:-8,y:2,z:8},{x:8,y:2,z:8}];
  var bladeShape=new T.Shape();
  bladeShape.moveTo(.05,-.018);
  bladeShape.bezierCurveTo(.22,-.05,.45,.0,.5,.04);
  bladeShape.lineTo(.5,.06);
  bladeShape.bezierCurveTo(.42,.04,.22,.005,.05,.022);
  bladeShape.closePath();
  var bladeGeo=new T.ExtrudeGeometry(bladeShape,{depth:.006,bevelEnabled:false,steps:1});
  bladeGeo.translate(0,0,-.003);
  var propellers=[];
  var motorPositions=[];
  for(var i=0;i<4;i++){
    var angle=Math.PI/4+(i*Math.PI/2);
    var dir=armDirs[i];
    var armLen=.95;
    var arm=new T.Mesh(new T.BoxGeometry(armLen,.05,.05),matCarbon);arm.castShadow=true;
    addPart(arm,{x:Math.cos(angle)*armLen/2,y:.02,z:Math.sin(angle)*armLen/2},dir,{x:0,y:-angle,z:0});
    var joint=new T.Mesh(new T.SphereGeometry(.075,18,12),matBrushed);joint.castShadow=true;
    addPart(joint,{x:Math.cos(angle)*.18,y:.04,z:Math.sin(angle)*.18},{x:dir.x*.7,y:dir.y+1,z:dir.z*.7});
    var mx=Math.cos(angle)*.95,mz=Math.sin(angle)*.95;
    motorPositions.push({x:mx,z:mz,angle:angle});
    var mountPlate=new T.Mesh(new T.CylinderGeometry(.13,.13,.025,20),matBrushed);
    addPart(mountPlate,{x:mx,y:.06,z:mz},{x:dir.x,y:dir.y+2,z:dir.z});
    var motorBody=new T.Mesh(new T.CylinderGeometry(.105,.115,.13,20),matMotor);motorBody.castShadow=true;
    addPart(motorBody,{x:mx,y:.135,z:mz},{x:dir.x*1.1,y:dir.y+2.5,z:dir.z*1.1});
    var motorTop=new T.Mesh(new T.CylinderGeometry(.10,.105,.03,20),matMotorTop);
    addPart(motorTop,{x:mx,y:.215,z:mz},{x:dir.x*1.15,y:dir.y+3,z:dir.z*1.15});
    var stat=new T.Mesh(new T.SphereGeometry(.018,8,6),i<2?matLEDWhite:matLEDGreen);
    addPart(stat,{x:mx*1.05,y:.135,z:mz*1.05},{x:dir.x*1.2,y:dir.y+2,z:dir.z*1.2});
    var propGroup=new T.Group();
    var hub=new T.Mesh(new T.CylinderGeometry(.045,.045,.035,16),matBrushed);propGroup.add(hub);
    for(var b=0;b<3;b++){
      var blade=new T.Mesh(bladeGeo,matProp);
      blade.rotation.y=(b*Math.PI*2)/3;blade.castShadow=true;
      propGroup.add(blade);
    }
    var disc=new T.Mesh(new T.CircleGeometry(.5,40),new T.MeshBasicMaterial({color:0x6366f1,transparent:true,opacity:.045,side:T.DoubleSide,depthWrite:false}));
    disc.rotation.x=-Math.PI/2;propGroup.add(disc);
    addPart(propGroup,{x:mx,y:.255,z:mz},{x:dir.x*1.3,y:dir.y+5,z:dir.z*1.3});
    propellers.push({prop:propGroup,dir:i%2===0?1:-1});
  }

  // NAV LEDs at arm tips + halo sprites
  var navMats=[matLEDWhite,matLEDWhite,matLEDRed,matLEDGreen];
  var navColors=[0xffffff,0xffffff,0xff3a4f,0x22ff8a];
  motorPositions.forEach(function(mp,i){
    var led=new T.Mesh(new T.SphereGeometry(.04,14,10),navMats[i]);
    addPart(led,{x:mp.x*1.02,y:.0,z:mp.z*1.02},{x:armDirs[i].x*.6,y:-2,z:armDirs[i].z*.6});
    var halo=new T.Sprite(new T.SpriteMaterial({map:TEX_GLOW,color:navColors[i],transparent:true,opacity:.8,blending:T.AdditiveBlending,depthWrite:false}));
    halo.scale.set(.5,.5,1);
    addPart(halo,{x:mp.x*1.02,y:.0,z:mp.z*1.02},{x:armDirs[i].x*.7,y:-2.2,z:armDirs[i].z*.7});
  });

  // GIMBAL + CAMERA + LENS
  var gimbalRing=new T.Mesh(new T.TorusGeometry(.13,.018,12,36),matBrushed);gimbalRing.rotation.x=Math.PI/2;
  addPart(gimbalRing,{x:0,y:-.12,z:.05},{x:0,y:-7,z:0});
  var camBox=new T.Mesh(new T.BoxGeometry(.18,.12,.16),matChassis);camBox.castShadow=true;
  addPart(camBox,{x:0,y:-.18,z:.08},{x:0,y:-7,z:5});
  var lensRing=new T.Mesh(new T.CylinderGeometry(.062,.07,.05,20),matLensRing);
  addPart(lensRing,{x:0,y:-.18,z:.16},{x:0,y:-6,z:6},{x:Math.PI/2,y:0,z:0});
  var lensGlass=new T.Mesh(new T.CylinderGeometry(.046,.046,.012,20),matLens);
  addPart(lensGlass,{x:0,y:-.18,z:.187},{x:0,y:-6,z:7},{x:Math.PI/2,y:0,z:0});
  var lensHalo=new T.Sprite(new T.SpriteMaterial({map:TEX_GLOW,color:0x22d3ee,transparent:true,opacity:.55,blending:T.AdditiveBlending,depthWrite:false}));
  lensHalo.scale.set(.32,.32,1);
  addPart(lensHalo,{x:0,y:-.18,z:.21},{x:0,y:-6,z:7});

  // ASSEMBLY ANIMATION
  var assemblyDone=false;
  if(window.gsap){
    gsap.ticker.fps(60);
    var tl=gsap.timeline({delay:.25});
    parts.forEach(function(p,i){
      var stagger=i*0.045;
      tl.to(p.position,{x:p.userData.targetPos.x,y:p.userData.targetPos.y,z:p.userData.targetPos.z,duration:.95,ease:"power3.out"},stagger);
      tl.to(p.rotation,{x:p.userData.targetRot.x,y:p.userData.targetRot.y,z:p.userData.targetRot.z,duration:.9,ease:"power2.out"},stagger);
      tl.to(p.scale,{x:1,y:1,z:1,duration:.65,ease:"back.out(1.7)"},stagger);
    });
    gsap.fromTo(cam.position,{z:7.4,y:1.85},{z:5.4,y:1.2,duration:2.4,ease:"power2.inOut",delay:.15});
    tl.call(function(){
      assemblyDone=true;
      var words=document.querySelectorAll('#drone-cta-text span');
      words.forEach(function(w,i){setTimeout(function(){w.classList.add('show')},i*260)});
      var pill=document.getElementById('drone-cta-pill');
      if(pill) setTimeout(function(){pill.classList.add('show')},words.length*260+280);
    },null,parts.length*0.045+0.45);
  }else{
    parts.forEach(function(p){p.position.set(p.userData.targetPos.x,p.userData.targetPos.y,p.userData.targetPos.z);p.rotation.set(p.userData.targetRot.x,p.userData.targetRot.y,p.userData.targetRot.z);p.scale.set(1,1,1)});
    assemblyDone=true;
    showCta();
  }

  // MOUSE FOLLOW (scoped to hero, frame-rate independent)
  var mxN=0,myN=0;
  var heroWrap=canvas.parentElement;
  if(heroWrap){
    heroWrap.addEventListener('mousemove',function(e){
      var r=heroWrap.getBoundingClientRect();
      mxN=Math.max(-1,Math.min(1,((e.clientX-r.left)/r.width)*2-1));
      myN=Math.max(-1,Math.min(1,-(((e.clientY-r.top)/r.height)*2-1)));
    });
    heroWrap.addEventListener('mouseleave',function(){mxN=0;myN=0;});
  }

  // RENDER LOOP — delta time, pause when off-screen / tab hidden
  var clock=new T.Clock();
  var t=0,rafId=0,inView=true,tabActive=true;
  function lerpFactor(rate,dt){return 1-Math.exp(-rate*dt);}
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;if(inView&&tabActive&&!rafId)loop();},{threshold:0.08,rootMargin:'40px'}).observe(canvas);
  }
  document.addEventListener('visibilitychange',function(){
    tabActive=!document.hidden;
    if(tabActive&&inView&&!rafId)loop();
  });

  function loop(){
    rafId=0;
    if(!inView||!tabActive)return;
    var dt=Math.min(clock.getDelta(),0.033);
    t+=dt;
    if(assemblyDone){
      drone.rotation.y+=dt*0.42;
      drone.rotation.x=Math.sin(t*0.55)*0.05;
      drone.position.y=Math.sin(t*1.05)*0.10;
      var hover=Math.sin(t*1.05);
      shadowDisc.scale.setScalar(1+hover*0.06);
      shadowDisc.material.opacity=0.85-Math.abs(hover)*0.25;
      propellers.forEach(function(p){p.prop.rotation.y+=10.5*p.dir*dt;});
    }else{
      propellers.forEach(function(p){p.prop.rotation.y+=0.55*p.dir*dt;});
    }
    points.rotation.y+=dt*0.065;
    var camEase=lerpFactor(6,dt);
    cam.position.x+=(mxN*0.45-cam.position.x)*camEase;
    cam.position.y+=(1.2+myN*0.28-cam.position.y)*camEase;
    cam.lookAt(0,0.05,0);
    renderer.render(scene,cam);
    rafId=requestAnimationFrame(loop);
  }

  if(heroCanvas){
    heroCanvas.classList.remove('is-loading');
    heroCanvas.classList.add('is-ready');
  }
  loop();
}

/* ============ CATEGORY 3D TILT (desktop, idle) ============ */
function bootTilt(){
  document.querySelectorAll('.tilt, .tilt-soft').forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=e.clientX-r.left,y=e.clientY-r.top;
      var rx=((y/r.height)-.5)*-8;var ry=((x/r.width)-.5)*8;
      if(card.classList.contains('use-orbit-item')){
        var circle=card.querySelector('.use-orbit-circle');
        if(circle) circle.style.transform='translateY(-4px) perspective(600px) rotateX('+rx+'deg) rotateY('+ry+'deg) scale(1.03)';
        return;
      }
      card.style.transform='translateY(-6px) perspective(800px) rotateX('+rx+'deg) rotateY('+ry+'deg)';
      card.style.setProperty('--mx',(x/r.width)*100+'%');
      card.style.setProperty('--my',(y/r.height)*100+'%');
    });
    card.addEventListener('mouseleave',function(){
      if(card.classList.contains('use-orbit-item')){
        var circle=card.querySelector('.use-orbit-circle');
        if(circle) circle.style.transform='';
        return;
      }
      card.style.transform='';
    });
  });
}
if(window.matchMedia('(pointer: fine)').matches){
  if('requestIdleCallback' in window){requestIdleCallback(bootTilt,{timeout:2500});}
  else{window.addEventListener('load',bootTilt);}
}

/* ============ SCROLL REVEAL (CSS + IO, no ScrollTrigger) ============ */
(function(){
  var sel='.section-head, .cat-card, .product-card, .trust-card, .bundle-card, .use-card, .use-orbit-item, .testimonial-card, .blog-card, .showcase-inner > *';
  var nodes=document.querySelectorAll(sel);
  if(!nodes.length)return;
  if(!('IntersectionObserver' in window)){nodes.forEach(function(el){el.classList.add('td-visible');});return;}
  nodes.forEach(function(el){
    el.classList.add('td-reveal');
    new IntersectionObserver(function(entries,o){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('td-visible');o.unobserve(e.target);}});
    },{threshold:0.08,rootMargin:'0px 0px -6% 0px'}).observe(el);
  });
})();

/* ============ QUICK ADD TO CART + SALES UX ============ */
(function bootSalesUx(){
  function syncHeaderHeight(){
    var header=document.getElementById('site-header');
    if(!header)return;
    document.documentElement.style.setProperty('--td-header-h',header.offsetHeight+'px');
  }
  var promoClose=document.getElementById('promo-close');
  if(promoClose){
    promoClose.addEventListener('click',function(){
      document.body.classList.add('promo-hidden');
      var bar=document.getElementById('promo-bar');
      if(bar)bar.style.display='none';
      syncHeaderHeight();
    });
  }
  syncHeaderHeight();
  window.addEventListener('resize',syncHeaderHeight);
  window.addEventListener('load',syncHeaderHeight);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(syncHeaderHeight);}
  if(window.ResizeObserver){
    var headerEl=document.getElementById('site-header');
    if(headerEl)new ResizeObserver(syncHeaderHeight).observe(headerEl);
  }
  function showToast(){
    var t=document.getElementById('td-cart-toast');
    if(!t)return;
    t.hidden=false;
    clearTimeout(showToast._t);
    showToast._t=setTimeout(function(){t.hidden=true;},5000);
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.add-cart[data-variant-id]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    var id=btn.getAttribute('data-variant-id');
    if(!id)return;
    btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json();})
      .then(function(){
        btn.classList.add('added');btn.textContent='✓';
        var c=document.getElementById('td-cart-count');
        if(c){var n=parseInt(c.textContent,10)||0;c.textContent=n+1;}
        showToast();
        setTimeout(function(){btn.classList.remove('added');btn.textContent='+';btn.disabled=false;},1400);
      })
      .catch(function(){btn.disabled=false;window.location.href='/cart';});
  });
})();
